import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
const { useTranslation } = Hooks;
const { getUrl } = Util;
import store from "store";

// import { Borrow, Repay } from "components/pages/trade/_cmpt/modalTriggerBtn";
import Borrow from "components/pages/trade/_cmpt/modalTriggerBtn/borrow";
import Repay from "components/pages/trade/_cmpt/modalTriggerBtn/repay";
import LiquidationRate from "components/pages/trade/_cmpt/liquidation/rate";
import LiquidationPrice from "components/pages/trade/_cmpt/liquidation/price";
import MarketTypeTab from "../../marketTypeTab";
import EtfBtns from "../../etfBtns";
import Fee from "../../_cmpt/fee";
import TradeLimit from "../../_cmpt/tradeLimit";
import TradeMarket from "../../_cmpt/tradeMarket";

import styles from "./index.module.scss";

import { LayoutEnum } from "store/app";
import { TradeSideEnum, TradeTypeEnum } from "store/trade";
import { OptionProps } from "../../index";

interface Props extends OptionProps, HTMLAttributes<HTMLDivElement> {}

const Main: React.FC<Props> = ({ hasFutures, hasEtf, tradeType, setTradeType }) => {
  const t = useTranslation();

  const { layout } = store.app;
  const { name, isLever } = store.market;
  const { isLogin } = store.user;

  return (
    <div className={styles.main}>
      <MarketTypeTab>
        <div className={styles.tabOption}>
          {hasFutures && (
            <a href={getUrl("/futures/trade/" + name)} className={cx("linkClear", styles.link)}>
              {t("trade.futures")}
            </a>
          )}
          {hasFutures && hasEtf && <span className={styles.split}></span>}
          {hasEtf && <EtfBtns />}
        </div>
      </MarketTypeTab>

      <div className={styles.option}>
        <div>
          <button className={cx("btnTxt", "btnHover", { [styles.btnAtv]: tradeType === TradeTypeEnum.limit })} onClick={() => setTradeType(TradeTypeEnum.limit)}>
            {t("trade.limit")}
          </button>
          <button className={cx("btnTxt", "btnHover", { [styles.btnAtv]: tradeType === TradeTypeEnum.market })} onClick={() => setTradeType(TradeTypeEnum.market)}>
            {t("trade.market")}
          </button>
        </div>
        <div>
          {isLever && isLogin && (
            <>
              <LiquidationRate />
              <LiquidationPrice style={{marginLeft: "8px"}} />
              <span></span>
              <Borrow />
              {layout !== LayoutEnum.fullscreen && <Repay/>}
              <span></span>
            </>
          )}
          {/*<a href={getUrl("/rate")} className={cx("linkClear", styles.link)}>*/}
          {/*  {t("trade.fee")}*/}
          {/*</a>*/}
          <Fee className={styles.link}/>
        </div>
      </div>

      <div className={styles.content}>
        {tradeType === TradeTypeEnum.limit && (
          <>
            <TradeLimit tradeSide={TradeSideEnum.buy} />
            <TradeLimit tradeSide={TradeSideEnum.sell} />
          </>
        )}
        {tradeType === TradeTypeEnum.market && (
          <>
            <TradeMarket tradeSide={TradeSideEnum.buy} />
            <TradeMarket tradeSide={TradeSideEnum.sell} />
          </>
        )}
      </div>
    </div>
  );
};

export default observer(Main);
